import React, { useState } from 'react'
import i18n from 'constants/strings'
import { PlayerStats as PlayerStatsType } from 'types/global'
import RatingsRangeGraphic from '../generic/RatingsRangeGraphic'
import styles from './styles/profile-styles.module.scss'
import FilterDropdown from 'components/generic/FilterDropdown'
import { TABLET_BREAKPOINT } from 'constants/global'
import useWindowSize from '../../hooks/use-windowSize'
import MobileFilter from '../generic/MobileFilterSelector/MobileFilterSelector'
import { roundDownWtn } from 'utils'

const WtnHiLo: React.FC<PlayerStatsType> = stats => {
  const pastYear: string = i18n.t('strPlayerStats.pastYeartitle')
  const allTime: string = i18n.t('strPlayerStats.allTimeTitle')
  const windowWidth = useWindowSize().width

  const options = [
    { key: null, label: allTime },
    { key: 1, label: pastYear },
  ]

  const [selectedOption, setSelectedOption] = useState(options[0].key)

  const bounds = (
    stats: PlayerStatsType | undefined,
    period: number | null,
    type: 'singles' | 'doubles',
    bound: 'min' | 'max'
  ) => {
    const periodField = period ? 'wtnBoundsThisYear' : 'wtnBoundsAllTime'
    const res = stats?.[periodField]?.[type]?.[bound]
    return res ? roundDownWtn(res) : undefined
  }

  return (
    <>
      <h2>{i18n.t('strPlayerStats.ratingHighsAndLows')}</h2>

      {windowWidth && windowWidth > TABLET_BREAKPOINT && (
        <FilterDropdown
          options={options}
          selectedKey={selectedOption}
          onSelect={({ key }) => setSelectedOption(key)}
        />
      )}
      {windowWidth && windowWidth <= TABLET_BREAKPOINT && (
        <MobileFilter
          timePeriodFilterData={{
            timePeriodItems: options,
            selectedTimePeriodItem: selectedOption,
            updateTimePeriodFilterValue: setSelectedOption,
          }}
          classNames={{ filterBar: styles.filterBar }}
        />
      )}

      <div className={styles.highsLowsGraphsWrapper}>
        <div>
          <h4 className={styles.heading}>{i18n.t('strPlayerStats.singles')}</h4>
          <RatingsRangeGraphic
            high={bounds(stats, selectedOption, 'singles', 'min')}
            low={bounds(stats, selectedOption, 'singles', 'max')}
          />
        </div>
        <div>
          <h4 className={styles.heading}>{i18n.t('strPlayerStats.doubles')}</h4>
          <RatingsRangeGraphic
            high={bounds(stats, selectedOption, 'doubles', 'min')}
            low={bounds(stats, selectedOption, 'doubles', 'max')}
          />
        </div>
      </div>
    </>
  )
}

export default WtnHiLo
